module.exports = __webpack_public_path__ + "img/94.03ec5228.jpg";